import {INTERNAL_PROJECTS, ProjectFeatureFlag} from 'common/report/constants';
import {featuresStore} from 'common/report/stores/features';
import {renameEvent} from 'common/report/util/events';

import {ANY_EVENT, FIRST_EVENT} from '../models/constants';
import {ConditionTab} from '../models/enums/builder-enums';

export {commaizeNumber, extend, isDefinedValue, objToQueryString, parseUrlQueryParams} from 'common/util';
export {pluralize, truncateMiddle} from 'common/util/string';
export {sorted} from 'common/util/array';
export {getIconForEvent, renameEvent} from 'common/report/util/events';
export {getIconForPropertyType, renameProperty, renamePropertyValue} from 'common/report/util/properties';

export {stringFilterMatches} from 'common/util/string';
export {eventWasOutside} from 'common/util/dom';
export {formatDate, parseDate, relativeToAbsoluteDate} from 'common/util/date';
export {insertAtIndex, removeByIndex, removeByValue, replaceByIndex} from 'common/util/array';

export {closestEl} from './dragging';

interface CustomEvent {
  custom: boolean;
  deleted: number;
  id: number;
  is_collect_everything_event: boolean;
  name: string;
}

export const isCustomEvent = (eventName: string): boolean => {
  return eventName.startsWith(`$custom_event:`);
};

export const displayNameForBehaviorEvent = (eventName: string, customEvents: CustomEvent[]): string => {
  let name;
  if (isCustomEvent(eventName)) {
    const customEventID = Number(eventName.slice(eventName.indexOf(`:`) + 1));
    const customEvent = customEvents.find((ev) => ev.id === customEventID);
    if (customEvent) {
      name = customEvent.name;
    } else {
      name = `Deleted Custom Event (${customEventID})`;
    }
  } else if (eventName === FIRST_EVENT) {
    name = `First event`;
  } else if (eventName === ANY_EVENT) {
    name = `Any event`;
  } else {
    name = renameEvent(eventName);
  }

  return name;
};

export const getHashParam = (param: string): string | null => {
  const hash = window.location.hash;
  const matches = new RegExp(`${param}=([^&]*)`).exec(hash);
  return matches ? matches[1] : null;
};

export const createPrimitiveTabData = (tab: string): Obj => {
  return {value: tab, label: tab, type: tab};
};

interface DataGroup {
  groupID: string;
  displayName: string;
}

export const createDataGroupTabData = (dataGroup: DataGroup): Obj => {
  return {
    value: dataGroup.groupID,
    label: dataGroup.displayName,
    type: ConditionTab.DataGroup,
  };
};

export const joinKeyPropertyFromStagedDimension = (stagedDimension) => {
  const {name, count, label} = stagedDimension;
  const type = stagedDimension.customProperty
    ? stagedDimension.customProperty.joinPropertyType
    : stagedDimension.joinPropertyType;
  return {name, label, type, count};
};

/** Defines if new query builder is enabled for the current session */
export function hasNewQBEnabled(projectId: string) {
  return (
    INTERNAL_PROJECTS.has(parseInt(projectId, 10)) ||
    featuresStore.value?.hasProjectFeatureFlag(ProjectFeatureFlag.QBCohorts)
  );
}
